// Constantes del modo urgente — replicar exactamente en Flutter
const MS_2H  = 2  * 60 * 60 * 1000; // anticipación mínima para reservas urgentes
const MS_24H = 24 * 60 * 60 * 1000; // ventana máxima de urgencia

/**
 * La reserva está dentro de la ventana urgente: entre 2h y 24h desde ahora.
 * Slot PERMITIDO y marcado como urgente (+35%).
 * @param {Date} fechaHoraUtc - fecha+hora de la reserva en UTC
 * @param {Date} ahoraUtc     - momento actual en UTC
 */
export function esUrgente(fechaHoraUtc, ahoraUtc) {
    if (!fechaHoraUtc || !ahoraUtc) return false;
    const desde = new Date(ahoraUtc.getTime() + MS_2H);
    const hasta = new Date(ahoraUtc.getTime() + MS_24H);
    return fechaHoraUtc >= desde && fechaHoraUtc <= hasta;
}

/**
 * La reserva está dentro de las próximas 2 horas.
 * Slot BLOQUEADO — el vendedor no tiene tiempo suficiente para desplazarse.
 * @param {Date} fechaHoraUtc
 * @param {Date} ahoraUtc
 */
export function esDemasiaPronto(fechaHoraUtc, ahoraUtc) {
    if (!fechaHoraUtc || !ahoraUtc) return false;
    const minimo = new Date(ahoraUtc.getTime() + MS_2H);
    return fechaHoraUtc > ahoraUtc && fechaHoraUtc < minimo;
}

/**
 * La reserva ya pasó.
 * Slot BLOQUEADO.
 * @param {Date} fechaHoraUtc
 * @param {Date} ahoraUtc
 */
export function esPasado(fechaHoraUtc, ahoraUtc) {
    if (!fechaHoraUtc || !ahoraUtc) return false;
    return fechaHoraUtc <= ahoraUtc;
}
